// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ResourcePositionLight_abstract extends PersistentObject {
  static $t: string = 'SagaBase.ResourcePositionLight';
  $t: string = 'SagaBase.ResourcePositionLight';

  public static GetMembers(): string[] {
    return ['Uid', 'Name', 'X', 'Y', 'CoordEpsgCode', 'ResTypeConst', 'ActivityStatus'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ResourcePositionLight_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Uid: Guid = GuidTools.Empty;
  public Name: string;
  public X: number = 0;
  public Y: number = 0;
  public CoordEpsgCode: string;
  public ResTypeConst: SagaBase.ResourceType = SagaBase.ResourceType.Undefined;
  public ActivityStatus: SagaBase.Interfaces.ActivityStatusType = SagaBase.Interfaces.ActivityStatusType.Unavailable;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.Uid;
  }
  get ParentObjId(): any {
    return this.Uid;
  }
  set ParentObjId(value: any) {
    this.Uid = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
